export const randomizePath = (linkWidth, height) => {
  const moveYMin = height * 0.5
  const moveYMax = height * 0.5
  const curveX1 = linkWidth * 0.1
  const curveX2 = linkWidth * 0.3
  const curveX3 = linkWidth * 0.65
  const curveYMin1 = height * 0.23
  const curveYMax1 = height * 0.43
  const curveYMin2 = height * 0.46
  const curveYMax2 = height * 0.66
  const curveYMin3 = height * 0.56
  const curveYMax3 = height * 0.76
  const endYMin = height * 0.5
  const endYMax = height * 0.5
  const moveY = Math.floor(Math.random() * (moveYMax - moveYMin)) + moveYMin
  const curveY1 = Math.floor(Math.random() * (curveYMax1 - curveYMin1)) + curveYMin1
  const curveY2 = Math.floor(Math.random() * (curveYMax2 - curveYMin2)) + curveYMin2
  const curveY3 = Math.floor(Math.random() * (curveYMax3 - curveYMin3)) + curveYMin3
  const endY = Math.floor(Math.random() * (endYMax - endYMin)) + endYMin

  // const newPath = `M5 ${moveY} Q ${curveX} ${curveY} ${linkWidth - 7} ${endY}`
  // d="M 5 15 Q 20 10, 60 17 T 130 20 T 190 15"
  const newPath = `M 3 ${moveY} Q ${curveX1} ${curveY1}, ${curveX2} ${curveY2} T ${curveX3} ${curveY3} T ${linkWidth - 3} ${endY}`

  return newPath
}

export const createSVG = (linkWidth, color, strokeWidth = 5, height) => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('width', linkWidth)
  svg.setAttribute('height', height)

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  const pathD = randomizePath(linkWidth, height)

  path.setAttribute('d', pathD)
  path.setAttribute('fill', 'transparent')
  path.setAttribute('stroke', color)
  path.setAttribute('stroke-width', strokeWidth)
  path.setAttribute('stroke-linecap', 'round')

  path.dataset.width = path.getTotalLength().toFixed(2)
  svg.appendChild(path)

  return svg
}
